var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useEffect, useMemo, useRef } from 'react';
import { createMarkup } from '../lib/utils';
import { useTranslation } from 'react-i18next';
const MARKUP_LINK_REGEX = /#md#\[(.*?)]\((.*?)\)#\/md#/gm;
const makeMarkupLinks = (str) => {
    let contentWithMarkdownHyperlink = str;
    const group = MARKUP_LINK_REGEX.exec(str);
    if (group && group.length > 2) {
        contentWithMarkdownHyperlink = contentWithMarkdownHyperlink.replace(MARKUP_LINK_REGEX, `<a href="${group[2]}" target="_blank">${group[1]}</a>`);
    }
    return contentWithMarkdownHyperlink;
};
const EMAIL_REGEX = /[A-Za-z0-9._%+-\\*]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}/gm;
const containsAnyEmailAddress = (str) => {
    return EMAIL_REGEX.test(str);
};
const LINK_ELEMENT_REGEX = /<a\b[^>]*>(.*?)<\/a>/;
const containAnyLinkElement = (str) => {
    return LINK_ELEMENT_REGEX.test(str);
};
const HYPERLINK_REGEX = /(https?:\/\/)([\w\\-])+\.{1}([a-zA-Z]{2,63})([\\/\w-]*)*\/?\??([^#\n\r]*)?#?([^\n\r]*)/gm;
const makeLinksIfPlainText = (str) => {
    const group = HYPERLINK_REGEX.exec(str);
    if (group && group.length > 2) {
        if (group[1] === 'https://') {
            return str.replace(HYPERLINK_REGEX, url => `<a href='${url}'>${url}</a>`);
        }
    }
    return str;
};
const makeLinks = (str) => {
    if (containsAnyEmailAddress(str) || containAnyLinkElement(str)) {
        return str;
    }
    return makeLinksIfPlainText(str);
};
export const HtmlContent = (_a) => {
    var { children, makeLinksTargetBlank, findLinksInText } = _a, props = __rest(_a, ["children", "makeLinksTargetBlank", "findLinksInText"]);
    const divRef = useRef(null);
    const { i18n } = useTranslation();
    useEffect(() => {
        var _a, _b;
        if (!makeLinksTargetBlank)
            return;
        for (const aTag of (_b = (_a = divRef.current) === null || _a === void 0 ? void 0 : _a.getElementsByTagName('a')) !== null && _b !== void 0 ? _b : []) {
            aTag.setAttribute('target', '_blank');
        }
    }, [makeLinksTargetBlank]);
    const content = useMemo(() => findLinksInText
        ? makeLinks(makeMarkupLinks(children))
        : makeMarkupLinks(children), [findLinksInText, children]);
    return (React.createElement("div", Object.assign({ dir: i18n.dir(), ref: divRef, dangerouslySetInnerHTML: createMarkup(content) }, props)));
};
//# sourceMappingURL=HtmlContent.js.map